import {createFileRoute} from "@tanstack/react-router";
import {z as zod} from "zod";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/bluestores/inviteBluestores",
)({
    validateSearch: zod.object({
        appId: zod.string().uuid().optional(),
        inviteSent: zod.boolean().optional(),
        inviteLink: zod.string().optional(),
    }),
    component: RouteComponent,
});
